import * as React from "react";
const SvgFiRrTimeForwardTen = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#062147" clipPath="url(#fi-rr-time-forward-ten_svg__a)">
      <path d="M21 15a3 3 0 0 0-3 3v3a3 3 0 0 0 6 0v-3a3 3 0 0 0-3-3m1 6a1 1 0 0 1-2 0v-3a1 1 0 0 1 2 0zM13 12V7a1 1 0 0 0-2 0v4H8a1 1 0 0 0 0 2h4a1 1 0 0 0 1-1" />
      <path d="M23 2a1 1 0 0 0-1 1v2.374A12 12 0 1 0 7.636 23.182q.176.066.364.068a1 1 0 0 0 .364-1.932A10.002 10.002 0 0 1 8.22 2.72 10 10 0 0 1 20.636 7H18a1 1 0 1 0 0 2h3a3 3 0 0 0 3-3V3a1 1 0 0 0-1-1" />
      <path d="M15.383 15.076a1 1 0 0 0-1.09.217l-3 3a1 1 0 0 0 1.414 1.414L14 18.414V23a1 1 0 0 0 2 0v-7a1 1 0 0 0-.617-.924" />
    </g>
    <defs>
      <clipPath id="fi-rr-time-forward-ten_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTimeForwardTen;
